import { lazy } from 'react'
import type { ComponentType, LazyExoticComponent } from 'react'

/**
 * 懒加载失败（网络抖动或发版后旧 chunk 短暂 404）时自动重试，
 * 重试仍失败则抛出原错误，由 ErrorBoundary 兜底展示可恢复界面。
 */
export function lazyWithRetry<E extends ComponentType<any>>(
  factory: () => Promise<{ default: E }>,
  retries = 1,
): LazyExoticComponent<E> {
  return lazy(async () => {
    let lastError: unknown
    for (let attempt = 0; attempt <= retries; attempt++) {
      try {
        if (attempt > 0) {
          await new Promise(resolve => setTimeout(resolve, 300 * attempt))
        }
        return await factory()
      } catch (error) {
        lastError = error
      }
    }
    throw lastError
  })
}
